/* eslint-disable indent */
import { useState, useEffect, useContext } from 'react';
import { ProjectField } from '.';
import { useParams } from 'react-router-dom';
import { api } from '../../services/api';
import { Project } from '../../types/ProjectType';
import { Field } from '../../types/FieldType';
import { FIELD_TYPE } from '../../FieldTypes';
import { LoadingContext } from '../../providers/loading';
import { UserDataContext } from '../../providers/userData';
import { OpenContext } from '../../providers/openModal';

export function ProjectFieldContainer() {
  const { contractId, projectId } = useParams();
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const { userData } = useContext(UserDataContext);
  const { setIsOpen } = useContext(OpenContext);
  const [modalSelect, setModalSelect] = useState({
    text: false,
    number: false,
    counter: false,
    datetime: false,
    image: false,
    options: false,
    label: false
  });
  const [isEditFieldModalOpen, setIsEditFieldModalOpen] = useState(false);
  const [onEditField, setOnEditField] = useState<Field>(Object);
  const [fieldTypeValue, setFieldTypeValue] = useState('');
  const [projectData, setProjectData] = useState<Project>({
    id: '',
    title: '',
    description: '',
    fields: [],
    is_active: false,
    owner_id: '',
    contract_id: ''
  });
  const [fieldsLength, setFieldsLength] = useState<number>(0);

  async function getProjectData() {
    setIsLoading({ value: true });
    await api.get(`/contracts/${contractId}/projects?id=${projectId}`, {
      headers: {
        'Authorization': `Bearer ${userData.token}`
      }
    })
      .then((response) => {
        setProjectData(response?.data?.projects);
      })
      .catch((error) => {
        console.log(error);
      });
    setIsLoading({ value: false });
  }

  function createField(fieldType: string, optionName?: string) {
    setFieldsLength(projectData?.fields?.length ?? 0);
    setIsEditFieldModalOpen(false);
    setIsOpen((prevState) => ({
      ...prevState,
      values: {
        ...prevState.values,
        [fieldType]: true
      }
    }));
    setModalSelect(prevState => ({
      ...prevState,
      [fieldType]: true
    }));

    if (optionName) {
      setFieldTypeValue(optionName);
    }
  }

  function onEdit(field: Field) {
    const selectedField = Object.entries(FIELD_TYPE).find(([, value]) => value === field.field_type_id);

    if (selectedField) {
      const fieldType = selectedField?.[0];
      setIsOpen((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          [fieldType]: true
        }
      }));
      setModalSelect(prevState => ({
        ...prevState,
        [fieldType]: true
      }));
      setIsEditFieldModalOpen(true);
    }

    if (selectedField?.[0] === 'checkbox' || selectedField?.[0] === 'radio' || selectedField?.[0] === 'dropdown') {
      setIsOpen((prevState) => ({
        ...prevState,
        values: {
          ...prevState.values,
          options: true
        }
      }));
      setModalSelect(prevState => ({
        ...prevState,
        options: true
      }));
      setIsEditFieldModalOpen(true);
    }

    if (field) {
      setOnEditField(field);
    }
  }

  async function updateFieldOrder(fieldsList: Field[]) {
    if (projectData?.fields) {
      for (const item of fieldsList) {
        const projectField = projectData.fields.find(field => field.field.id === item.field.id);
        if (projectField && item.field.order !== projectField.field.order) {
          await api.put(`/project/${projectId}/field?id=${item.field.id}`,
            {
              order: item.field.order,
            }
          )
            .then(async () => {
              setIsLoading({ value: true });
            })
            .catch(error => console.log(error));
        }
      }
    getProjectData();
    setIsLoading({ value: false });
    }
  }

  async function onDelete(fieldRow: Field, fieldsList: Field[]) {
    const { id: fieldId, project_id: projectId } = fieldRow;
    setIsLoading({ value: true });
    await api.delete(`/project/${projectId}/field?id=${fieldId}`)
      .then(() => {
        updateListAfterDelete(fieldsList, fieldRow);
      })
      .catch(error => console.log(error));
  }

  function updateListAfterDelete(fieldsList: Field[], fieldRow: Field){
    const foundField = fieldsList.findIndex((field) => field?.field?.id === fieldRow?.id);
    fieldsList.splice(foundField, 1);
    fieldsList.forEach((field, index) => field.field.order = index);
    updateFieldOrder(fieldsList);
  }

  useEffect(() => {
    getProjectData();
  }, []);

  return (
    <ProjectField
      project={projectData}
      onEditField={onEditField}
      isLoading={isLoading.value}
      fieldTypeValue={fieldTypeValue}
      modalSelect={modalSelect}
      isEditFieldModalOpen={isEditFieldModalOpen}
      createField={createField}
      onEdit={onEdit}
      onDelete={onDelete}
      getProjectData={getProjectData}
      updateFieldOrder={updateFieldOrder}
      fieldsLength={fieldsLength}
    />
  );
}
